<template>
  <Card :footerDivider="false" :title="$t('publicUsernameRetrievalChoice.general.title')">
    <template v-slot:content>
      <div>
        <p>{{ $t('publicUsernameRetrievalChoice.general.description') }}</p>
        <Radiogroup
          @input="radioChanged"
          id="forgot-username.choice-radiobutton"
          :items="getUsernameRadioItems()"
          :status="InputStatus[usernameRadioStatus as keyof typeof InputStatus]"
          :value="checked"
        >
        </Radiogroup>
      </div>
    </template>
    <template v-slot:footer>
      <div class="footer-cta footer-cta--left">
        <CustomButton
          @click="onSubmit"
          :buttonColor="ButtonColor.PRIMARY"
          :pendingState="pending"
          buttonId="forgot-username-choice-weiter-button"
          trackId="forgotUsername"
        >
          {{ $t('publicUsernameRetrievalChoice.submit.text') }}
        </CustomButton>
      </div>
    </template>
  </Card>
</template>
<script lang="ts" setup>
import {
  ButtonColor,
  Card,
  CustomButton,
  InputStatus,
  Radiogroup
} from 'de-zurich-ui-library'
import { onMounted, ref } from 'vue'
import type { KeycloakLoginOptions } from 'keycloak-js'
import { isAuthenticated } from '@/utils/KeycloakUtils'
import { initKeycloak } from '@/keycloak.setup'

interface Username {
  id: string
  label: string
}

const props = defineProps({
  usernameRadioItems: {
    type: Array<string>,
    default: []
  },
  usernameRadioName: {
    type: String,
    default: ''
  },
  usernameRadioStatus: {
    type: String,
    default: InputStatus.DEFAULT
  }
})

const checked = ref('')

const pending = ref(false)

onMounted(() => {
  if (props.usernameRadioItems.length === 1) {
    checked.value = props.usernameRadioItems[0]!
  }
})
const getUsernameRadioItems = (): Username[] => {
  return props.usernameRadioItems.map((value: string) => ({ id: value, label: value }))
}

const radioChanged = (val: string): void => {
  checked.value = val
}

const onSubmit = (): void => {
  pending.value = true
  const redirectUrl = (
    globalThis.location.origin +
    globalThis.ENV_CONFIG?.BASE_URL +
    globalThis.ENV_CONFIG?.REDIRECTS.ACCOUNT_LOGIN_ON_SUCCESS_REDIRECT
  ).replaceAll(/([^:]\/)\/+/g, '$1')
  const options: KeycloakLoginOptions = {
    loginHint: checked.value,
    redirectUri: redirectUrl
  }

  if (isAuthenticated()) {
    globalThis.keycloak.login(options)
  } else {
    initKeycloak(redirectUrl, checked.value)
  }
}
</script>
<style lang="scss" scoped>
span.error-message {
  font-size: 24px;
  color: var(--input-color-error);
}

b.error-message {
  padding-left: 5px;
  color: var(--input-color-error);
}
</style>
